// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { jsonObject } from "typedjson";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonCKBTxMember } from "./types/nervosTransaction";
import { TransactionWithScriptGroups } from "./types/nervosTransactionTypes";

@jsonObject
export default class SendNervTx extends PerunMessage {
  @jsonCKBTxMember() transaction: TransactionWithScriptGroups;

  constructor(transaction: TransactionWithScriptGroups) {
    super();
    this.transaction = transaction;
  }

  messageType(): MessageType {
    return SendNervTx;
  }

  messageTypeName(): MessageTypeName {
    return "SendNervTx";
  }
}
